import React from 'react';
import { Divider, Heading, Image, Stack, Text } from '@chakra-ui/react';
import fotoPedro from './data/assets/Main/pedro_serrano.jpg'
function About({ text }) {
    
    var md = require('markdown-it')({ breaks: true });
    const contenidoSobreMi1 = md.render(text.sobreMi1);
    const contenidoSobreMi2 = md.render(text.sobreMi2);
    const contenidoFormacion = md.render(text.formacion);

    return(
      <Stack direction={'column'} spacing='3%' alignItems='center' justifyContent='center' pb={['8%','8%','8%','8%']} pt={['30%','12%','12%','8%']}>
        <Stack direction={['column','column','column','row','row']} spacing='10%' alignItems={['center','center','center','center']} justifyContent='center' textAlign='left' px={['2%','2%','5%','0%']}>
          <Image src={fotoPedro} boxSize={['70%','70%','70%','22%','22%']} boxShadow={'20px 20px 20px #808080'}></Image>
          <Stack direction='column' spacing='2%'>
            <Heading textAlign={['center','center','center','left','left']}>{text.tit1}</Heading>
            <Text dangerouslySetInnerHTML={{__html: contenidoSobreMi1}} lineHeight={8} fontSize={['sm','xs','md','sm','sm']} textAlign={['center','center','center','left','left']}></Text>
            <Divider display={['block','none']} py='2%' />
            {/* <Text dangerouslySetInnerHTML={{__html: contenidoSobreMi2}} fontSize={['xs','xs','md','sm','sm']} px={'none'} textAlign={['center','center','center','left','left']}></Text> */}
          </Stack>
        </Stack>
        <Divider />
        <Stack spacing='2%' textAlign='center' py={['9%','3%']} px={['4%','0%','0%','0%']}>
          <Heading>{text.tit2}</Heading>
          <Text dangerouslySetInnerHTML={{__html: contenidoFormacion}} textAlign='center' fontSize='sm'></Text>
        </Stack>
      </Stack>
    );
}

export default About;